import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import { useDebounceValue } from 'hooks'
import { colors } from 'utils'
import Icon from '../Icon'
import FormGroup, { FormGroupProps } from '../FormGroup'

interface Props extends FormGroupProps {
    placeholder?: string
    value?: string
    onChange?: (e) => void
    className?: string
    debounce?: number
    onClick?: (e) => void
}

const S = {
    FormGroup: styled(FormGroup)`
        position: relative;
        margin: 0;
        padding: 0;
        & > span {
            position: absolute;
            top: 9px;
            right: 13px;
        }
        & > input {
            &::placeholder {
                font-size: 14px;
                color: #4E5155;
                opacity: 0.8;
            }
        }
    `
}

const SearchInput = ({
    placeholder,
    value = '',
    onChange = (e?: any) => e,
    debounce=500,
    ...props
}: Props) => {
    const [search, setSearch] = useState('')
    const searchParam = useDebounceValue(search, debounce)

    useEffect(() => {
        onChange(searchParam)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParam])

    useEffect(() => {
        // Control value from outside (eg: reset search, set default search ...)
        setSearch(value)
    }, [value])

    return (
        <S.FormGroup {...props}>
            <Form.Control
                type="text"
                placeholder={placeholder}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
            <Icon icon="search" size={20} color={colors.inputIcon} />
        </S.FormGroup>
    )
}

export default SearchInput
